export default "__VITE_ASSET__C5jl0b5T__"